import React, { useState, useEffect, useMemo } from 'react';
import { EnvProvider } from '../../contexts/Env'
import { HostProvider } from '../../contexts/Host'
import { ShopProvider } from '../../contexts/Shop'
import { CustomerProvider } from '../../contexts/Customer'
import { ExtensionsProvider } from '../../contexts/Extensions'
import { SubscriptionsProvider } from '../../contexts/Subscriptions'
import { RegistrationsProvider } from '../../contexts/Registrations'
import { OfficeHoursProvider } from '../../contexts/OfficeHours'
import { OfficeHourSubscriptionsProvider } from '../../contexts/OfficeHourSubscriptions'
import { LineItemsProvider } from '../../contexts/LineItems'
import { LineItemsExtensionProvider } from '../../contexts/LineItemsExtension'
import { EnrollmentsProvider } from '../../contexts/yolk/Enrollments'
import { StudentsProvider } from '../../contexts/Students'
import { OrdersProvider } from '../../contexts/Orders'
import { SellingPlansProvider } from '../../contexts/SellingPlans'
import { UserProvider } from '../../contexts/yolk/User'
import { ProductsProvider } from '../../contexts/Products'
import { SectionsProvider } from '../../contexts/yolk/Sections'
import { SubscriptionCodesProvider } from '../../contexts/SubscriptionCodes'
import { QuickViewsProvider } from '../../contexts/QuickViews'
import { RecursProvider } from '../../contexts/Recurs'
import Account from './Account'
import {AppProvider} from '@thinkwell/react.polaris';
import flatten from 'lodash/flatten'
import { ProductsYolkProvider } from "../../contexts/yolk/Products";

export default function Index(props) {
  const sellingPlanProps = window.productOptions && flatten(Object.keys(window.productOptions).map((variantId) => {
    const sellingPlanAllocations = window.productOptions[variantId].selling_plan_allocations || []
    return sellingPlanAllocations.map((sellingPlanAllocation) => {
      const sellingPlan = window.sellingPlans && window.sellingPlans[sellingPlanAllocation.selling_plan_id]
      if (sellingPlan) {
        sellingPlanAllocation.selling_plan = sellingPlan
      }
      return Object.assign({ variantId: variantId }, window.productOptions[variantId], {selling_plan_allocations: [sellingPlanAllocation]})
    })
  }))

  return (<AppProvider>
      <EnvProvider value={props.env}>
      <HostProvider value={window.thinkwell.config.host}>
      <ShopProvider value={props.shop_name}>
      <CustomerProvider value={props.customer}>
      <UserProvider value={props.user}>
      <OrdersProvider value={props.orders}>
      <RecursProvider value={props.recurs}>
      <SubscriptionCodesProvider value={props.subscription_codes}>
      <SectionsProvider value={props.sections}>
      <ProductsProvider value={props.products}>
      <ProductsYolkProvider>
      <ExtensionsProvider value={props.extensions}>
      <EnrollmentsProvider value={props.enrollments}>
      <OfficeHoursProvider value={props.office_hours}>
      <LineItemsProvider value={props.line_items_oh}>
      <OfficeHourSubscriptionsProvider>
      <LineItemsProvider value={props.line_items}>
      <LineItemsExtensionProvider value={props.line_items_extension_recur}>
      <SubscriptionsProvider>
      <RegistrationsProvider value={props.registrations}>
      <StudentsProvider value={props.students}>
      <SellingPlansProvider value={sellingPlanProps}>
      <QuickViewsProvider value={props.quick_views}>
      <Account />
    </QuickViewsProvider></SellingPlansProvider></StudentsProvider></RegistrationsProvider></SubscriptionsProvider></LineItemsExtensionProvider></LineItemsProvider></OfficeHourSubscriptionsProvider></LineItemsProvider></OfficeHoursProvider></EnrollmentsProvider></ExtensionsProvider></ProductsYolkProvider></ProductsProvider></SectionsProvider></SubscriptionCodesProvider></RecursProvider></OrdersProvider></UserProvider></CustomerProvider></ShopProvider></HostProvider></EnvProvider></AppProvider>)
}
